import { useEffect, useState } from 'react';
import { Button, Empty, Flex, Skeleton, Spin } from 'antd';

import { PostListParams, PostOrderColumn } from '../../../store/post/list';
import { usePostList } from './usePostList';
import Post from './Post';
import { PaginationProps } from '../../../store/types';
import { Post as PostType } from '../../../store/post';

import styles from './index.module.scss';

interface PostListProps {
  filter: Pick<
    PostListParams,
    | 'businessId'
    | 'businessName'
    | 'businessZipCode'
    | 'businessCity'
    | 'businessState'
    | 'user'
    | 'orderBy'
    | 'orderByColumn'
    | 'categoryId'
    | 'subCategoryId'
    | 'search'
  >;
  isHeader?: boolean;
}

function PostList({ filter, isHeader = false }: PostListProps) {
  const { getPosts, response, loading } = usePostList();

  const [listAll, setListAll] = useState<PostType[]>([]);

  useEffect(() => {
    if (response?.data) {
      if (filter) {
        setListAll([]);
        setListAll((prev) => [...(response?.data || [])]);
      } else {
        setListAll((prev) => [...prev, ...(response?.data || [])]);
      }
    }
  }, [response?.data]);

  const [pagination, setPagination] = useState<
    PaginationProps<PostOrderColumn>
  >({
    page: 1,
    pageSize: 10,
    orderBy: 'DESC',
    orderByColumn: 'createdAt',
  });

  useEffect(() => {
    getPosts({
      ...pagination,
      businessCity: filter.businessCity,
      businessName: filter.businessName,
      businessState: filter.businessState,
      businessZipCode: filter.businessZipCode,
      businessId: filter.businessId,
      status: 'published',
      user: filter.user,
      orderBy: filter.orderBy,
      orderByColumn: filter.orderByColumn,
      categoryId: filter.categoryId,
      subCategoryId: filter.subCategoryId,
      // businessId: 'e6669b5e-f361-462c-a851-640438f92532',
      // search: 'Mercato Metropolitano',
    });
  }, [
    filter.businessId,
    filter.user,
    filter.orderBy,
    filter.orderByColumn,
    filter.categoryId,
    filter.subCategoryId,
    filter.businessName,
    filter.businessZipCode,
    filter.businessState,
    filter.businessCity,
    pagination,
  ]);

  if (!response && loading) {
    return (
      <div className={styles.wrapper}>
        <Skeleton />
        <Skeleton />
      </div>
    );
  }

  if ((!response || response.data.length === 0) && !loading) {
    return (
      <div className={styles.wrapper}>
        <Empty description="No Post Found" />
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <Spin spinning={loading}>
        {listAll.length > 0
          ? listAll.map((post) => (
              <Post
                isHeader={isHeader}
                key={post.id}
                post={post}
                setPost={(postItem: PostType) => {
                  setListAll((prev) =>
                    prev.map((p) => (p.id === postItem.id ? postItem : p))
                  );
                }}
              />
            ))
          : null}
      </Spin>

      {response?.meta.hasNextPage ? (
        <Flex justify="center">
          <Button
            loading={loading}
            onClick={() =>
              setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
            }
          >
            Load more
          </Button>
        </Flex>
      ) : null}
    </div>
  );
}

export default PostList;
